export const currency = (currency: 'BRL' | 'USD', value: string | number) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency,
  }).format(Number(value))
};

export const percentage = (value: any, precision: number = 2) => {
  return (parseFloat(value) * 100).toFixed(precision) + '%'
} 